import PropTypes from "prop-types";

import { SFChip } from "@sf-core";
import { useTranslation } from "react-i18next";

const ActiveChip = ({ active }) => {
  const { t } = useTranslation();
  
  return (
    <SFChip color={active ? "green300" : "grey100"} size="small">
      {active ? t("activeChip.active") : t("activeChip.inactive")}
    </SFChip>
  );
};

ActiveChip.propTypes = {
  active: PropTypes.bool.isRequired,
};

export default ActiveChip;
